<template>
  <w-flex class="wrap fill-width justify-center grow row">
      <Splash class="mt5"/>
  </w-flex>
</template>

<script>
import Splash from '../components/Splash.vue'


export default {
  name: 'About',
  components: {
    Splash
  },
  props: {
  }
}
</script>

<style>
@font-face {
  font-family: "Open Sans";
  src: local("Open Sans"),
   url(../fonts/OpenSans/OpenSans-Regular.ttf) format("truetype");
}

.w-app{
  font-family: "Open Sans";
}

</style>
